import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
});

// ============================================================
// Flight Search (Bargain Finder Max v5 REST API)
// ============================================================

export async function searchFlights(params) {
  const response = await api.post('/search/flights', params);
  return response.data;
}

// ============================================================
// Parse BFM v5 grouped itinerary response into display-friendly format
// ============================================================

export function parseSearchResults(data) {
  const grouped = data?.groupedItineraryResponse;
  if (!grouped) return [];

  const scheduleDescs = grouped.scheduleDescs || [];
  const taxDescs = grouped.taxDescs || [];
  const fareComponentDescs = grouped.fareComponentDescs || [];
  const legDescs = grouped.legDescs || [];
  const itineraryGroups = grouped.itineraryGroups || [];

  const results = [];

  for (const group of itineraryGroups) {
    const groupDesc = group.groupDescription || {};
    const legDescriptions = groupDesc.legDescriptions || [];

    for (const itin of group.itineraries || []) {
      const pricingInfo = itin.pricingInformation?.[0] || {};
      const fare = pricingInfo.fare || {};
      const totalFare = fare.totalFare || {};
      const passengerInfo = fare.passengerInfoList?.[0]?.passengerInfo || {};

      // Build legs
      const legs = (itin.legs || []).map((leg, legIdx) => {
        const legRef = leg.ref;
        const legDesc = legDescs.find((ld) => ld.id === legRef) || {};
        const schedules = (legDesc.schedules || []).map((sched) => {
          const schedDesc = scheduleDescs.find((sd) => sd.id === sched.ref) || {};
          return {
            ...schedDesc,
            marriageGroup: sched.marriageGroup,
            connectionTime: sched.connectionTime,
          };
        });

        return {
          direction: legIdx === 0 ? 'outbound' : 'return',
          elapsedTime: legDesc.elapsedTime,
          schedules,
        };
      });

      results.push({
        id: `itin-${results.length}`,
        legs,
        totalPrice: totalFare.totalPrice || totalFare.amount,
        currency: totalFare.currency || 'USD',
        baseFare: totalFare.baseFareAmount,
        taxes: totalFare.totalTaxAmount,
        passengerType: passengerInfo.passengerType,
        pricingSource: pricingInfo.pricingSubsource,
        raw: itin, // keep raw data for booking
      });
    }
  }

  // Sort by price
  results.sort((a, b) => (a.totalPrice || 0) - (b.totalPrice || 0));

  return results;
}

// ============================================================
// Booking (Booking Management API v1 REST API)
// ============================================================

export async function createBooking(params) {
  const response = await api.post('/booking/create', params);
  return response.data;
}

export async function getBooking(confirmationId) {
  const response = await api.post('/booking/get', { confirmationId });
  return response.data;
}

export async function cancelBooking(params) {
  const response = await api.post('/booking/cancel', params);
  return response.data;
}

// ============================================================
// Health check
// ============================================================

export async function checkHealth() {
  const response = await api.get('/health');
  return response.data;
}
